// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers'
import { application } from '../application'

const context = require.context('.', true, /_controller\.js$/)
application.load(definitionsFromContext(context))
